/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, Spin } from 'antd';
import './index.scss';
import { useEffect, useMemo, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { translate } from 'libs';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IModalPreviewProps {
  onRef?: any;
}

export enum ETypeMenuFooter {
  TERM = 'TERM',
  PRIVACY = 'PRIVACY',
  SUPPORT = 'SUPPORT',
}

const ViewPDF = ({ onRef }: IModalPreviewProps) => {
  const [data, setVisible] = useState({ visible: false, url: null, type: null });
  const [loading, setLoading] = useState(false);

  const { url, type, visible } = data;

  useMemo(() => {
    if (onRef) onRef(handleVisible);
    return () => {
      if (onRef) onRef(undefined);
    };
  }, []);

  useEffect(() => {
    if (!url) return;
    renderData(url);
  }, [url]);

  function handleVisible(data) {
    setVisible(data);
    setLoading(true);
  }

  const renderPage = async ({ pdfDoc, scale }) => {
    const totalPage = pdfDoc._pdfInfo.numPages;
    const element = document.getElementById('element_canvas_append');
    if (!element) return;
    element.innerHTML = '';
    for (let i = 1; i <= totalPage; i++) {
      const canvas = document.createElement('canvas');
      const page = await pdfDoc.getPage(i);
      const ctx = canvas.getContext('2d');
      const viewport = page.getViewport({ scale });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.style.width = '100%';
      element.append(canvas);
      page.render({
        canvasContext: ctx,
        viewport: viewport,
      });
    }
  };

  const renderData = async (file) => {
    const loadingTask = pdfjs.getDocument(file);
    const pdfDoc = await loadingTask.promise;
    await renderPage({ pdfDoc, scale: 5 });
    setLoading(false);
  };

  return (
    <Modal
      width={'90%'}
      closable={false}
      maskClosable={false}
      className="modal modal-preview"
      title={type === ETypeMenuFooter.TERM ? translate('menu.term_use') : translate('menu.privacy')}
      visible={visible}
      footer={
        <Button className="btn-cancel" onClick={() => handleVisible(false)} size="large">
          {translate('common.popup.closeBtn')}
        </Button>
      }
      centered
    >
      <Spin spinning={loading}>
        <div
          style={{ textAlign: 'center', background: '#535659', padding: 5 }}
          id="element_canvas_append"
        />
      </Spin>
    </Modal>
  );
};

export default ViewPDF;
